"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var isEmpty_1 = __importDefault(require("lodash/isEmpty"));
var moment_1 = __importDefault(require("moment"));
var Policies_1 = require("../../classes/Policies");
var InstructorDashboardController = /** @class */ (function () {
    function InstructorDashboardController($state, UsersModel, UserService, store, $sce, VueStoreFactory) {
        this.loading = true;
        this.$sce = $sce;
        this.$state = $state;
        this.UsersModel = UsersModel;
        this.VueStoreFactory = VueStoreFactory;
        this.currentUser = UserService.getCurrentUser();
        this.store = store;
        this.goToSession = this.goToSession.bind(this);
        this.setup().then(function (loading) {
            // setup complete
        });
    }
    InstructorDashboardController.prototype.setup = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, response, p, policies, notification;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.getNextSession()];
                    case 1:
                        _a.nextsessiondata = _b.sent();
                        if ((0, isEmpty_1.default)(this.nextsessiondata)) {
                            this.nextDrive = {};
                        }
                        else {
                            this.nextDrive = this.nextsessiondata.nextDrive;
                            this.nextDriveDate = this.nextsessiondata.nextDriveDate;
                            this.untilDrive = this.nextsessiondata.untilDrive;
                        }
                        return [4 /*yield*/, this.UsersModel.getInstructorByID(this.currentUser.id)];
                    case 2:
                        response = _b.sent();
                        /* @ts-ignore */
                        this.currentUser = response;
                        p = this.VueStoreFactory.state.policies.policies;
                        policies = (0, Policies_1.createFromPolicyAPIResponse)({ policies: p });
                        try {
                            notification = policies.getPolicyByName('notifications').getMetaValueByKey('globalinstructornotification');
                            if (!(0, isEmpty_1.default)(notification)) {
                                this.hasAdminMessage = true;
                                this.adminMessage = this.$sce.trustAsHtml(notification);
                            }
                        }
                        catch (Error) {
                            this.hasAdminMessage = false;
                            this.adminMessage = "";
                        }
                        this.dsConfig = {
                            'nav': {
                                'use_team_calendar': false,
                                'instructor_can_create_lessons': false
                            }
                        };
                        try {
                            this.dsConfig.nav.use_team_calendar = policies.getPolicyByName('calendar').getMetaValueByKey('use_team_calendar');
                        }
                        catch (Error) {
                            this.dsConfig.nav.use_team_calendar = false;
                        }
                        try {
                            this.dsConfig.nav.instructor_can_create_lessons = policies.getPolicyByName('drives').getMetaValueByKey('instructor_can_create_lessons');
                        }
                        catch (Error) {
                            this.dsConfig.nav.instructor_can_create_lessons = false;
                        }
                        this.loading = false;
                        return [2 /*return*/, this.loading];
                }
            });
        });
    };
    InstructorDashboardController.prototype.goToSession = function () {
        if (this.nextDrive.entity_type === 'drive') {
            this.$state.go('drivecoach.instructor.dashboard.drive', { 'driveId': this.nextDrive.id });
        }
        if (this.nextDrive.entity_type === 'drivescoutclass') {
            var data = {
                id: this.nextDrive.course_id,
                date: this.nextDrive.date,
                class_id: this.nextDrive.id,
                start: new Date(this.nextDrive.start).toLocaleTimeString('en-US', { hour: 'numeric', minute: 'numeric' }),
                end: new Date(this.nextDrive.end).toLocaleTimeString('en-US', { hour: 'numeric', minute: 'numeric' }),
                instructor: this.nextDrive.instructor,
                instructor_id: this.nextDrive.instructor_id,
            };
            data.date = new Date(this.nextDrive.start).toLocaleDateString();
            this.VueStoreFactory.dispatch('SET_VIEW_COURSE', data);
            this.$state.go('drivecoach.instructor.dashboard.course.view', { 'courseId': data.id });
        }
        if (this.nextDrive.entity_type === 'event') {
            this.$state.go('drivecoach.instructor.dashboard.event', { 'eventId': this.nextDrive.id });
        }
    };
    InstructorDashboardController.prototype.getNextSession = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, date, Error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.UsersModel.getNextInstructorEntity({ 'id': this.currentUser.id })];
                    case 1:
                        response = _a.sent();
                        if ((0, isEmpty_1.default)(response.entity)) {
                            return [2 /*return*/, {}];
                        }
                        date = (0, moment_1.default)(response.entity.date).format('YYYY-MM-DD');
                        return [2 /*return*/, {
                                'nextDrive': response.entity,
                                'nextDriveDate': (0, moment_1.default)(date + ' ' + response.entity.time),
                                'untilDrive': (0, moment_1.default)(date + ' ' + response.entity.time).format('h:mm a')
                            }];
                    case 2:
                        Error_1 = _a.sent();
                        console.error(Error_1);
                        // throw Error;
                        return [2 /*return*/, {}];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return InstructorDashboardController;
}());
InstructorDashboardController.$inject = ['$state', 'UsersModel', 'UserService', 'store', '$sce', 'VueStoreFactory'];
exports.default = InstructorDashboardController;
